/**
 * @generated SignedSource<<c79d5289fcdb3d66354d4f72524ce0da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type titleStoryStyleCardTitleArticle$data = {
  readonly socialHeadline: string | null | undefined;
  readonly " $fragmentType": "titleStoryStyleCardTitleArticle";
};
export type titleStoryStyleCardTitleArticle$key = {
  readonly " $data"?: titleStoryStyleCardTitleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"titleStoryStyleCardTitleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "titleStoryStyleCardTitleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "socialHeadline",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "322fb74f3680049fe719cad4f0dbe2fc";

export default node;
